import { ThemeColors } from '~/themes/colors'

interface ColorSet {
  Icon: ThemeColors
  Button: ThemeColors
  Border: ThemeColors
  BoxShadow: ThemeColors
}

interface IncomingCallButtonColors {
  Button: {
    Background: ThemeColors
    Border: ThemeColors
    Hover: {
      Background: ThemeColors
      Border: ThemeColors
      BoxShadow: ThemeColors
    }
    Active: {
      Background: ThemeColors
      Border: ThemeColors
      BoxShadow: ThemeColors
    }
  }
  CallIcons: {
    Reject: ColorSet
    Accept: ColorSet
    Hold: ColorSet
  }
}

export const incomingCallButtonColors: IncomingCallButtonColors = {
  Button: {
    Background: {
      default: 'gray.100',
    },
    Border: {
      default: 'achromatic.transparent',
    },
    Hover: {
      Background: {
        default: 'white',
      },
      Border: {
        default: 'gray.400',
      },
      BoxShadow: {
        default: 'mask.gray.1300.10',
      },
    },
    Active: {
      Background: {
        default: 'white',
      },
      Border: {
        default: 'gray.400',
      },
      BoxShadow: {
        default: 'achromatic.none',
      },
    },
  },
  CallIcons: {
    Reject: {
      Icon: {
        default: 'white',
      },
      Button: {
        default: 'red.800',
      },
      Border: {
        default: 'achromatic.transparent',
      },
      BoxShadow: {
        default: 'achromatic.none',
      },
    },
    Accept: {
      Icon: {
        default: 'white',
      },
      Button: {
        default: 'green.700',
      },
      Border: {
        default: 'achromatic.transparent',
      },
      BoxShadow: {
        default: 'mask.gray.1300.10',
      },
    },
    Hold: {
      Icon: {
        default: 'green.700',
      },
      Button: {
        default: 'gray.300',
      },
      Border: {
        default: 'gray.400',
      },
      BoxShadow: {
        default: 'achromatic.none',
      },
    },
  },
}
